import { UserTypes } from 'types/GlobalTypes';
import { getColor } from 'utilities/SystemUtils';

export const AppUserTypeChip = ({ userType }: { userType: UserTypes | null }) => {
  return (
    <span className={`custom_chip px-3 custom_chip--rounded custom_chip--${getColor(userType as UserTypes)}`}>
      {userType ? (
        <span className='overflow-ellipsis text-capitalize' title={userType}>
          {userType}
        </span>
      ) : (
        '-'
      )}
    </span>
  );
};

export default AppUserTypeChip;
